import { Compiler, ComponentFactoryResolver, ComponentRef, Injectable,  Injector,  NgModuleFactory,  NgModuleRef,  Type,  ViewContainerRef } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class DynamicComponentLoader {

    constructor(private cfr: ComponentFactoryResolver,
    private compiler: Compiler,
    private injector: Injector,
        ) {

    }
    private vcr: ViewContainerRef;
    setViewContainer(vcr: ViewContainerRef) {
        this.vcr = vcr;
    }

    //  createComponent<T>(component:Type<T>):ComponentRef<T> {
    //     return this.vcr.createComponent(this.cfr.resolveComponentFactory(component)) as ComponentRef<T>;
    // }

    createComponent<T>(component:Type<T>,resolver:ComponentFactoryResolver = null):ComponentRef<T> {
      if(resolver == null)
      {
        return this.vcr.createComponent(this.cfr.resolveComponentFactory(component)) as ComponentRef<T>;
      }
      else
      {
        return this.vcr.createComponent(resolver.resolveComponentFactory(component)) as ComponentRef<T>;

      }
  }


    loadModule(m: any): Promise<NgModuleRef<any>> {
        return m.then(elementModuleOrFactory => {
          if (elementModuleOrFactory instanceof NgModuleFactory) {
            return elementModuleOrFactory;
          } else {
            return this.compiler.compileModuleAsync(elementModuleOrFactory);
          }
        }).then(moduleFactory => moduleFactory.create(this.injector))
      }
    
}